import { businessActions, businessApiActions } from './business';
import { contentActions, contentApiActions } from './content';
import { teamActions, teamApiActions } from './team';
import { userActions, userApiActions } from './user';

const actions = {
  business: {
    ...businessActions.business,
    ...contentActions.business,
    ...teamActions.business,
    ...userActions.business
  }
}

export const apiActions = {
  business: {
    ...businessApiActions.business,
    ...contentApiActions.business,
    ...teamApiActions.business,
    ...userApiActions.business
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/business/actions.js